/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.categories.create.rules.controllers', [
  'acme.common.service.membership',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.factory.notice'
])

.controller('MembershipCategoriesCreateRulesController', [ '$scope', '$state', 'MembershipService', 'HelpersService', 'NoticeFactory', 'ValidateService', function($scope, $state, MembershipService, HelpersService, NoticeFactory, ValidateService) {

    $scope.membershipCategoriesCreateRules = {

      model: {},

      isSubmitted: false,

      validators: [],

      notice: new NoticeFactory(),

      init: function() {
        this.model = MembershipService.getModel();

        $scope.$on('MembershipService::Update', this.onMembershipServiceUpdate);
        $scope.$on('MembershipCategoriesCreate::Update', this.onMembershipCategoryCreateUpdate);
        $scope.$on('MembershipCategoriesCreate::Save', this.onMembershipCategoryCreateSave);

        if($state.params.id) {
          this.validators = [
            {
              field: 'membership-categories-create-rules-numcards-min',
              greater: {
                message: 'Please enter a number greater than 0',
                test: function () {
                  return {
                    greater: ($scope.membershipCategoriesCreateRules.model.numOfCardHolders) ? $scope.membershipCategoriesCreateRules.model.numOfCardHolders : 0,
                    less: 0,
                    equalTo: false
                  };
                }
              }
            }];

          ValidateService.addFieldTests(this.validators);
        }
      },

      isValid: function(field) {
        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.check(this.validators, field);
        }
        return r;
      },

      getErrors: function(fieldName) {
        return ValidateService.getError(fieldName);
      },

      save: function() {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        MembershipService.setModel(this.model);

        this.isSubmitted = true;
        ValidateService.validate(this.validators);
      },

      success: {
        init: function(response) {}
      },
      error: {
        init: function(response) {}
      },

      onMembershipServiceUpdate: function(e, data) {
        //the parent model has changed
        $scope.membershipCategoriesCreateRules.model = MembershipService.getModel();
      },

      onMembershipCategoryCreateUpdate: function(e, data) {
        // a tab has changed
        var self = $scope.membershipCategoriesCreateRules;

        if (data.view === 'rules') {
          self.onMembershipServiceUpdate();
        }
      },

      onMembershipCategoryCreateSave: function(e, data) {
        $scope.membershipCategoriesCreateRules.save();
      }

    };

    $scope.membershipCategoriesCreateRules.init();

}]);